import { select, throttle } from 'redux-saga/effects';
import queryString from 'query-string';
import { offsetChanged } from '../actions/facet';
import history from '@wix/da-shared-react/pkg/redux/routing/history';
import { getIsDuperbrowseActive } from '@wix/da-shared-react/pkg/Duperbrowse/redux/selectors';
import { getPageForOffset } from '../selectors/app';

export function* updateOffsets({
  payload: { offset = 0 },
}: ReturnType<typeof offsetChanged>) {
  const isDuperbrowseActive = yield select(getIsDuperbrowseActive);

  // we've no business updating offsets while in duperbrowse
  if (isDuperbrowseActive) {
    return;
  }

  const newPage = yield select(getPageForOffset, offset);

  const { page: currentPage, ...restQuery } = queryString.parse(
    window.location.search
  );

  if (newPage === parseInt(currentPage as string, 10)) {
    return;
  }

  const newQuery = queryString.stringify(
    newPage <= 1 ? restQuery : { ...restQuery, page: newPage }
  );

  history.replace({
    search: newQuery && `?${newQuery}`,
  });
  // if we have offset tracking, disable scroll restoration for this page
  window.history.scrollRestoration = 'manual';
}

export default function* appSagaRoot() {
  yield throttle(500, offsetChanged, updateOffsets);
}
